import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

export function analyticsSessionId() {
  const key = "teamwork_analytics_session";
  let id = localStorage.getItem(key);
  if (!id) {
    id = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(key, id);
  }
  return id;
}

export function trackDownload(details = {}) {
  return api.post("/analytics/events", {
    event_type: "download",
    session_id: analyticsSessionId(),
    path: window.location.pathname,
    ...details,
  }).catch(() => {});
}

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    api.post("/analytics/events", {
      event_type: "pageview",
      session_id: analyticsSessionId(),
      path: `${location.pathname}${location.search}`,
    }).catch(() => {});
  }, [location.pathname, location.search]);

  return null;
}

